import React, {useContext, useState, useEffect} from 'react';
import {ShippingInstructionContext} from "./shipping-instruction-context";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import {DocumentService} from "../../services";
import _ from "underscore";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";

function OtherDocumentSection(props) {
    const {data, setData, methods, otherDocuments} = useContext(ShippingInstructionContext);
    const {ref} = methods;
    const [list, setList] = useState([]);
    const [open, setOpen] = useState(false);
    const [dirty, setDirty] = useState(false);

    
    useEffect(() => {
        if(dirty){
            props.checkIfDirty(dirty);
        }
    },[dirty]);
    
    const refreshDocumentList = (sectionId) => {
        const setIds = data.otherDocuments
            .filter(s => s.sectionId === sectionId)
            .map(s => s.documentId);
        const theList = otherDocuments.filter(s => !_.contains(setIds, s.id));
        setList(theList);
    }

    const onOrdersChanged = (value, row) => {
        setDirty(true);
        
        const otherDocuments = data.otherDocuments.slice();
        let theDocument = _.find(otherDocuments, {       
            id: row.id,      
            sectionId: row.sectionId,           
        });
        if(theDocument === undefined){
        theDocument = row;
        }
        let theRow = theDocument
        theRow.documentOrder = value;
        setData({...data, otherDocuments: otherDocuments});
    }

    const onOriginalsChanged = (value, row) => {
        setDirty(true);
        const otherDocuments = data.otherDocuments.slice();
        let theDocument = _.find(otherDocuments, {
            id: row.id,      
            sectionId: row.sectionId,      
        });
        if(theDocument === undefined){
            theDocument = row;
            }
        let theRow = theDocument;
        theRow.numberOfOriginals = value;
        setData({...data, otherDocuments: otherDocuments});
    }

    const onCopiesChanged = (value, row) => {
        setDirty(true);
        const otherDocuments = data.otherDocuments.slice();
        let theDocument = _.find(otherDocuments, {
            id: row.id,      
            sectionId: row.sectionId,      
        });
        if(theDocument === undefined){
            theDocument = row;
            }
        let theRow = theDocument;
        theRow.numberOfCopies = value;
        setData({...data, otherDocuments: otherDocuments});
    }

    const removeRow = (row) => {
        setDirty(true);
        let otherDocuments = data.otherDocuments.slice();
        let theDocument = _.find(otherDocuments, {
            id: row.id,      
            sectionId: row.sectionId,      
        });
        if(theDocument === undefined){
            theDocument = row;
            }
        otherDocuments = otherDocuments.filter(obj => obj.documentId !== row.documentId);
        setData({...data, otherDocuments: otherDocuments});
    };

    const onDocumentAdd = ss => {
        setDirty(true);
        DocumentService
            .getById(ss.id)
            .then((response) => {
                var otherDocuments = data.otherDocuments.slice();
                let theSectionDocument =[]
                for(let document of otherDocuments){
                   if(document.sectionId === props.section.id){
                    theSectionDocument.push(document)
                   }
                }               
                otherDocuments.push({
                    documentId: ss.id,
                    documentName: response.data.title,
                    numberOfCopies: 1,
                    numberOfOriginals: 1,
                    documentOrder: theSectionDocument.length+1,
                    sectionId: props.section.id
                });
                setData({...data, otherDocuments: otherDocuments});
                handleClose();
            });

    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = (sectionId) => {
        refreshDocumentList(sectionId);
        setOpen(true);
    }


    return (
        <Grid>
            <Grid item xs={12}>
                {
                    (!props.section.countryDefaultSection || data.overrideCountryDefaults) &&
                    <Button color="primary" onClick={() => handleOpen(props.section.id)}>Add Other Documents</Button>
                }

                {
                    data?.otherDocuments.filter(d => (d.sectionId === props.section.id)).length > 0 &&
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Documents</TableCell>
                                    <TableCell>Order</TableCell>
                                    <TableCell>Originals</TableCell>
                                    <TableCell>Copies</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    data?.otherDocuments?.filter(d => (d.sectionId === props.section.id)).map((row, i) => (
                                        <>
                                            {/* <TableRow key={'row-' + i}>
                                               
                                                <TableCell  style={{padding: 0, margin: 0, paddingLeft: 50, fontSize: 14, fontWeight: 'bold'}}>
                                                    {row.documentName}
                                                </TableCell>
                                                <TableCell
                                                    style={{padding: 0, paddingLeft: 5, margin: 0, maxWidth: '100px'}}
                                                    component="td"
                                                    scope="row">
                                                </TableCell>
                                                <TableCell
                                                    style={{padding: 0, paddingLeft: 5, margin: 0, maxWidth: '100px'}}
                                                    component="td"
                                                    scope="row">
                                                </TableCell>
                                                <TableCell
                                                    style={{padding: 0, paddingLeft: 5, margin: 0, maxWidth: '100px'}}
                                                    component="td"
                                                    scope="row">
                                                </TableCell>
                                                <TableCell style={{padding: 0, margin: 0, paddingLeft: 10}}>
                                                    <IconButton size="small" aria-label="delete"
                                                                onClick={() => removeDocumentSet(row)}>
                                                        <DeleteIcon color="error"/>
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow> */}
                                           
                                                <TableRow key={'member-' + i}>
                                                    <TableCell style={{padding: 0, paddingLeft: 50, margin: 0}}
                                                               component="td"
                                                               scope="row">
                                                        {row.documentName}
                                                    </TableCell>
                                                    <TableCell style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        paddingLeft: 5,
                                                        maxWidth: '100px'
                                                    }}>
                                                        <TextField type="number" ref={ref} size="small"
                                                                   variant="outlined"
                                                                   value={row.documentOrder}
                                                                   onChange={(e) => onOrdersChanged(e.target.value, row)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        paddingLeft: 5,
                                                        maxWidth: '100px'
                                                    }}>
                                                        <TextField type="number" ref={ref} size="small"
                                                                   variant="outlined"
                                                                   value={row.numberOfOriginals}
                                                                   onChange={(e) => onOriginalsChanged(e.target.value, row)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{
                                                        padding: 0,
                                                        margin: 0,
                                                        paddingLeft: 5,
                                                        maxWidth: '100px'
                                                    }}>
                                                        <TextField type="number" ref={ref} size="small"
                                                                   variant="outlined"
                                                                   value={row.numberOfCopies}
                                                                   onChange={(e) => onCopiesChanged(e.target.value, row)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={{padding: 0, margin: 0, paddingLeft: 10}}>
                                                        <IconButton size="small" aria-label="delete"
                                                                    onClick={() => removeRow(row)}>
                                                            <DeleteIcon color="error"/>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                        </>
                                    ))
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                }
            </Grid>

            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Add Documents </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please add the Documents here.
                    </DialogContentText>

                    {list.length > 0 &&
                        <Grid>
                            <Grid item xs={12}>
                                <TableContainer component={Paper}>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Documents</TableCell>
                                                <TableCell>&nbsp;</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                list.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell style={{padding: 10, paddingLeft: 10, margin: 0}}
                                                                   component="td"
                                                                   scope="row">
                                                            {row.title}

                                                        </TableCell>
                                                        <TableCell style={{padding: 0, margin: 0, paddingLeft: 5}}>
                                                            <Button onClick={() => onDocumentAdd(row)}>Add</Button>
                                                        </TableCell>
                                                    </TableRow>))
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    }
                    {
                        list.length === 0 &&
                        <>There is no document set that can be added to this shipping instruction.</>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>


        </Grid>
    );
}

export default OtherDocumentSection;